<template>
  <div class="sova-club-step">
    <div
      v-for="step in steps"
      class="sova-club-step__item sova-club-step__item"
      :class="{ 'sova-club-step__item sova-club-step__item_active': step == result.step }"
    >
      <span class="sova-club-step__circle">
        <span class="sova-club-step__number">{{ step }}</span>
        <span class="sova-club-step__check">
          <svg class="sova-club-step__icon"><use xlink:href="#svg-check"></use></svg>
        </span>
      </span>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

defineProps(['result']);
const steps = ref([1, 2, 3]);
</script>

<style lang="scss" scoped>
.sova-club-step {
  display: flex;
  margin-bottom: 24px;
  &__item {
    display: flex;
    align-items: center;
    &:after {
      content: '';
      display: block;
      height: 1px;
      width: 100%;
      flex-grow: 1;
      background-color: var(--background-black);
    }
    &:nth-child(1),
    &:nth-child(2) {
      flex-grow: 1;
    }
    &_active {
      &:after {
        background-color: #f6f6f6;
      }
      .sova-club-step__check {
        display: none;
      }
      .sova-club-step__number {
        display: block;
        color: #fff;
      }
      & ~ .sova-club-step__item {
        .sova-club-step__check {
          @include point-md {
            display: none;
          }
        }
        .sova-club-step__number {
          display: block;
          color: var(--color-main);
        }
        .sova-club-step__circle {
          background-color: #f6f6f6;
        }
        &:after {
          background-color: #f6f6f6;
        }
      }
    }
  }
  &__circle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    text-align: center;
    border-radius: 50%;
    background-color: var(--background-black);
    width: 32px;
    height: 32px;
  }
  &__icon {
    width: 20px;
    height: 20px;
    fill: #fff;
  }
  &__number {
    font-weight: 600;
    font-size: rem(16);
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #fff;
    @include point-md {
      display: none;
    }
  }
  &__check {
    display: none;
    @include point-md {
      display: block;
    }
  }
}
</style>
